import { ChangeDetectionStrategy, Component, ComponentFactoryResolver, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { BLOCK_ALL, GestureController, NavParams, Platform, Slides, ViewController } from 'ionic-angular';
var SlideCmp = (function () {
    function SlideCmp(_cfr, viewCtrl, gestureCtrl, navParams, plt) {
        this._cfr = _cfr;
        this.viewCtrl = viewCtrl;
        this.navParams = navParams;
        this.plt = plt;
        this.isWatchDetail = false;
        this.initalX = 0;
        this.initalY = 0;
        this.canBack = false;
        this.testClick = new EventEmitter();
        console.log('navparams', navParams);
        this.d = navParams.data.opts;
        this.imgSlides = this.navParams.data.component.list;
        this.gestureBlocker = gestureCtrl.createBlocker(BLOCK_ALL);
        this.viewCtrl.didEnter.subscribe(this.onDidEnter.bind(this));
    }
    SlideCmp.prototype.doClick = function (ev) {
        var _this = this;
        clearTimeout(this.timeout);
        if (!this.temp) {
            this.temp = new Date();
        }
        else {
            this.tempTime = this.temp;
            this.temp = new Date();
        }
        // 单击事件倒计时
        this.timeout = setTimeout(function () {
            _this.slideDown(ev);
        }, 400);
        // 两次点击时间差
        var clickBuffer = this.temp - this.tempTime;
        // 如果双击 立即执行双击函数 并且清除单击事件倒计时
        if (clickBuffer && clickBuffer < 400) {
            this.doDoubleClick(ev);
            clearTimeout(this.timeout);
        }
    };
    SlideCmp.prototype.doDoubleClick = function (ev) {
        var imgScale = ev.target;
        var imgWrap = imgScale.parentElement.parentElement;
        imgScale.style.transition = 'transform 0.33s';
        if (!this.isWatchDetail) {
            imgScale.style.transform = 'scale(2)';
        }
        else {
            imgScale.style.transform = 'scale(1)';
            imgWrap.style.transform = 'translate(0,0)';
            this.initalX = 0;
            this.initalY = 0;
        }
        this.isWatchDetail = !this.isWatchDetail;
    };
    SlideCmp.prototype.slideDown = function (ev) {
        var imgScale = ev.target;
        var imgWrap = imgScale.parentElement.parentElement;
        this.changeCB(this.slides._activeIndex);
        imgScale.style.transform = 'scale(1)';
        imgWrap.style.transform = 'translate(0,0)';
        this.viewCtrl.dismiss();
    };
    SlideCmp.prototype.panmove = function (ev) {
        var imgWrap = ev.target.parentElement.parentElement;
        var evX = ev.deltaX;
        var evY = ev.deltaY;
        if (this.isWatchDetail) {
            imgWrap.style.transform = 'translate(' + (evX + this.initalX) + 'px,' + (evY + this.initalY) + 'px)';
            imgWrap.style.transition = 'transform 0s';
        }
    };
    SlideCmp.prototype.panleft = function (ev) {
        // 图片放大后宽高
        var _imgWidth = ev.target.getBoundingClientRect().width;
        var _imgHeight = ev.target.getBoundingClientRect().height;
        // 屏幕宽高
        var _width = this.plt.width();
        var _height = this.plt.height();
        // 临界值
        var _criticalWidth = (_imgWidth - _width) / 2;
        var _criticalHeight = (_imgHeight - _height) / 2;
        var imgWrap = ev.target.parentElement.parentElement;
        if (this.isWatchDetail) {
            // 下次移动时赋予初始值
            this.initalX += ev.deltaX;
            this.initalY += ev.deltaY;
            // 超出临界值后返回
            if (this.initalX > _criticalWidth) {
                imgWrap.style.transform = 'translate(' + _criticalWidth + 'px,' + this.initalY + 'px)';
                imgWrap.style.transition = 'transform .33s';
                this.initalX = _criticalWidth;
            }
            if (this.initalX < -_criticalWidth) {
                imgWrap.style.transform = 'translate(' + -_criticalWidth + 'px,' + this.initalY + 'px)';
                imgWrap.style.transition = 'transform .33s';
                this.initalX = -_criticalWidth;
            }
            if (this.initalY > _criticalHeight) {
                imgWrap.style.transform = 'translate(' + this.initalX + 'px,' + _criticalHeight + 'px)';
                imgWrap.style.transition = 'transform .33s';
                this.initalY = _criticalHeight;
            }
            if (this.initalY < -_criticalHeight) {
                imgWrap.style.transform = 'translate(' + this.initalX + 'px,' + -_criticalHeight + 'px)';
                imgWrap.style.transition = 'transform .33s';
                this.initalY = -_criticalHeight;
            }
        }
    };
    SlideCmp.prototype.ngAfterViewInit = function () {
        if (this.navParams.data) {
            this.changeCB = this.navParams.data.component.change;
        }
        console.log('slide', this.slides);
        this.slides['_initSlides']();
        this.slides.slideTo(this.navParams.data.component.index, 0);
        // this.ref.markForCheck();
        console.log('ngAfterViewInit');
    };
    SlideCmp.prototype.ngAfterContentInit = function () {
        console.log('ngAfterContentInit');
    };
    SlideCmp.prototype.onDidEnter = function () {
        console.log('ondidenter');
    };
    SlideCmp.decorators = [
        { type: Component, args: [{
                    selector: 'slide-cmp',
                    template: "\n    <ion-backdrop></ion-backdrop>\n    <div class=\"slide-wrapper\">\n      <div class=\"slidewrap\">\n        <ion-slides class=\"slide-content-wrap\" pager=\"true\">\n          <ion-slide *ngFor=\"let slide of imgSlides\" [ngClass]=\"{'swiper-no-swiping': isWatchDetail}\">\n            <img #img style=\"display:block\" [src]=\"slide.url\" (click)=\"doClick($event)\" (pan)='panmove($event)' (panend)='panleft($event)'\n              (dblclick)=\"doDoubleClick()\">\n          </ion-slide>\n        </ion-slides>\n      </div>\n    </div>\n  ",
                    styles: ["\n    .slide-wrapper,\n    .slide-content,\n    .slidewrap {\n      height: 100%;\n      width: 100%;\n    }\n    \n    .slide-wrapper {\n      position: absolute;\n      z-index: 10;\n    }\n    \n    slide-content.slidewrap {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0px;\n    }\n    \n    slide-cmp {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n    }\n  "],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    SlideCmp.ctorParameters = function () { return [
        { type: ComponentFactoryResolver, },
        { type: ViewController, },
        { type: GestureController, },
        { type: NavParams, },
        { type: Platform, },
    ]; };
    SlideCmp.propDecorators = {
        '_viewport': [{ type: ViewChild, args: ['viewport', { read: ViewContainerRef },] },],
        'testClick': [{ type: Output },],
        'slides': [{ type: ViewChild, args: [Slides,] },],
        'img': [{ type: ViewChild, args: ['img',] },],
    };
    return SlideCmp;
}());
export { SlideCmp };
//# sourceMappingURL=slide-component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/components/slide-component.js
// module id = 154
// module chunks = 20